import rest from "lib/rest";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, FormGroup, Label, ModalBody, ModalFooter, ModalHeader, Row, Input } from "reactstrap";
import rotas from "services/rotas";
import Swal from "sweetalert2";

const Sessoes = ({onClose, setSessao}) => {

  const [sessao_id, setSessao_id] = useState('');
  const [listaSessoes, setListaSessoes] = useState([]);
  useEffect(() => {
    listarSessoes();
  }, [])

  const onChange = (sessao_id) =>{    
    setSessao_id(sessao_id)
  }

  const selecionarSessao = () =>{
    if(sessao_id == ''){
      Swal.fire('Atenção','Por favor selecione uma sessão!','warning');
    }else{
      setSessao(sessao_id);
      onClose();
    }
  }

  const listarSessoes = () => {
    const url = rotas.pedidoSessoes;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success == 'S') {
        setListaSessoes(ret.lista);
      } else {
        Swal.fire('Atenção', 'Erro na consulta de sessoes!', 'error');
      }
    })
  }

  const setNovaSessao = () => {
    Swal.fire({
      title: "Confirma a criação de nova sessão?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoSessoes;
        return rest.post(url, {});
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {
          listarSessoes();
        } else {
          Swal.fire('Atenção', 'Erro na criação de nova sessão!', 'error');
        }
      }
    });
  }

  const apagarSessao = () =>{

    if(sessao_id == ''){
      Swal.fire('Atenção','Por favor selecione uma sessão!','warning');
      return;
    }

    Swal.fire({
      title: "Confirma a remoção da sessão?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoSessoes;
        return rest.del(url + '?sessao_id=' + sessao_id);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {
          listarSessoes();
        } else {
          Swal.fire('Atenção', 'Erro na remoção da sessão!', 'error');
        }
      }
    });
  }

  return (
    <>
      <ModalHeader>Selecione uma Sessão</ModalHeader>

      <ModalBody>
        <Row>
          <Col md='2'>
            <span className="d-flex justify-content-center">ID Sessão</span>
          </Col>

          <Col md='3'>
            <span className="d-flex justify-content-center">Data de Início</span>
          </Col>

          <Col md='3'>
            <span className="d-flex justify-content-center">Vendedor</span>
          </Col>

          <Col md='2'>
            <span className="d-flex justify-content-center">Status</span>
          </Col>

          <Col md='2'>
            <span className="d-flex justify-content-center">Selecionar</span>
          </Col>
        </Row>

        {listaSessoes.map((sessao,idx) =>

          <Row className="my-2" key={`row-sessao-${idx}`}>
            <Col md='2'>
              <span className="d-flex justify-content-center">{sessao.pedidos_sessao_id}</span>
            </Col>

            <Col md='3'>
              <span className="d-flex justify-content-center">{moment(sessao.dt_inicio).format('DD/MM/YYYY hh:mm:ss')}</span>
            </Col>

            <Col md='3'>
              <span className="d-flex justify-content-center">{sessao.usuario}</span>
            </Col>

            <Col md='2'>
              <span className="d-flex justify-content-center">{sessao.status}</span>
            </Col>

            <Col md='2'>
              <span className="d-flex justify-content-center">
                <FormGroup check inline className="pb-2">
                  <Label check>
                    <Input
                      type="checkbox"
                      id="gerar_comissao_fp"
                      onChange={()=>{onChange(sessao.pedidos_sessao_id)} }
                      checked={sessao_id == sessao.pedidos_sessao_id ? true : false}
                    />
                    <span className="form-check-sign" />{' '}
                  </Label>
                </FormGroup>{" "}
              </span>
            </Col>

          </Row>

        )}

      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={selecionarSessao}>Selecionar Sessão</Button>
            <Button className="bg-info" onClick={setNovaSessao}>Adicionar Sessão</Button>
            <Button className="bg-danger" onClick={apagarSessao}>Apagar Sessão</Button>
            <Button color="secondary" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>

      </ModalFooter>
    </>
  )
}

export default Sessoes;